import { createSelector } from '@ngrx/store';
import { AppState } from '../reducers';

export const selectTemplates = (state: AppState) => state.sheetTemplateManagement.templates;

export const sheetTemplates = createSelector(selectTemplates, (templates) => templates);